import { EnumWeighing } from '@Hooks/Orders/useWeighing';
import { useMemo } from 'react';

export function useWeighingProcess(
    weighingType: EnumWeighing,
    grossWeight: number | undefined,
    tareWeight: number | undefined,
) {
    return useMemo(() => {
        const isWeighingIn = weighingType === EnumWeighing.Gross;

        const grossWeightIsEmpty = grossWeight === undefined || grossWeight === 0;
        const tareWeightIsEmpty = tareWeight === undefined || tareWeight === 0;

        const bothWeightsAreSet = !grossWeightIsEmpty && !tareWeightIsEmpty;

        if (isWeighingIn) {
            return {
                isComplete: !grossWeightIsEmpty,
                label: 'Einwiegung',
                bothWeightsAreSet,

                highlightBrutto: grossWeightIsEmpty,
                highlightTare: !grossWeightIsEmpty && tareWeightIsEmpty,
            };
        } else {
            return {
                isComplete: !tareWeightIsEmpty,
                label: 'Auswiegung',
                bothWeightsAreSet,

                highlightBrutto: grossWeightIsEmpty && !tareWeightIsEmpty,
                highlightTare: tareWeightIsEmpty,
            };
        }
    }, [weighingType, grossWeight, tareWeight]);
}
